var _style, _defs, _rect, _path, _path2, _path3, _path4, _path5, _defs2, _rect2, _defs3, _rect3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _polygon, _path16, _polygon2, _path17, _polygon3, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 186.3 125.7",
    style: {
      enableBackground: "new 0 0 186.3 125.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill:url(#SVGID_3_);}\n\t.st1{fill:#697C89;}\n\t.st2{fill:url(#SVGID_4_);}\n\t.st3{fill:#FE6A20;}\n\t.st4{clip-path:url(#SVGID_6_);fill:url(#SVGID_7_);}\n\t.st5{clip-path:url(#SVGID_9_);fill:url(#SVGID_10_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M60,47.1C52.6,60,45.1,72.9,37.7,85.7c-1,1.8-2.1,3.7-3.1,5.5c-1,1.8,0.3,4.3,2.4,4.3h44.5h6.2 c2.1,0,3.4-2.5,2.4-4.3c-2-3.5-4-7.1-6-10.6c-1.8-3.1-6.6-0.4-4.8,2.7c1.2,2.1,2.4,4.3,3.7,6.4H43.2h-1.4 C48.4,78.4,55,67,61.7,55.5c0.2-0.4,0.5-0.8,0.7-1.2c1.5,2.5,2.7,4.5,4.7,8c1.8,3.1,6.6,0.2,4.8-2.9c-2.9-5.1-4.2-7.1-7.1-12.2 c-0.5-0.9-1.5-1.4-2.4-1.4C61.4,45.8,60.5,46.2,60,47.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -256.8054,
    y1: 350.097,
    x2: -256.468,
    y2: 350.097,
    gradientTransform: "matrix(166.552 0 0 -166.552 42805.707 58380.0117)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF3C11"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE6A20"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.6,
    y: 45.8,
    className: "st0",
    width: 57.6,
    height: 49.8
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.1,36.5c1-1.8,2.1-3.5,3.1-5.3c1-1.8-0.3-4.1-2.4-4.1H44.3h-6.2c-2.1,0-3.4,2.3-2.4,4.1c2,3.5,4,7,6,10.5 c1.8,3.1,6.6,0.3,4.8-2.8c-2-3.5-4-6.8-6-10.3c-0.8,1.4-1.6,2.7-2.4,4.4h44.5h6.2c-0.8-1.7-1.6-3-2.4-4.4 C79,41.3,71.6,54.1,64.1,67c-1,1.8-2.1,3.6-3.1,5.3c-1.8,3.1,3,5.9,4.8,2.8"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.6,105.6c-8.9,6.6-19.8,10.5-31.7,10.5c-29.4,0-53.3-23.9-53.3-53.3S33.5,9.6,62.8,9.6 c29.4,0,53.3,23.9,53.3,53.3c0,4.1-0.5,8.2-1.4,12.1h2.8c0.9-3.9,1.3-7.9,1.3-12.1c0-30.9-25.1-56-56-56s-56,25.1-56,56 c0,30.9,25.1,56,56,56c11.8,0,22.7-3.6,31.7-9.9V105.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.1723,
    y1: 62.8382,
    x2: 125.8485,
    y2: 62.8382
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF3C11"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE6A20"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.6,112.6c-9.2,5.9-20,9.2-31.7,9.3c-32.6-0.1-59-26.4-59.1-59.1c0.1-32.6,26.4-59,59.1-59.1 c32.6,0.1,59,26.4,59.1,59.1c0,4.1-0.4,8.2-1.3,12.1h3.9c0.8-3.9,1.2-7.9,1.2-12.1C125.7,28.1,97.5,0,62.8,0C28.1,0,0,28.1,0,62.8 c0,34.7,28.1,62.8,62.8,62.8c11.6,0,22.4-3.1,31.7-8.6V112.6z"
  })), /*#__PURE__*/React.createElement("g", null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M128,81.2l1.5,0c0.3,0,0.5-0.2,0.5-0.5l0-1c0-0.3-0.2-0.5-0.5-0.5l-11.8,0l-1.7,0c-0.3,0-0.5,0.2-0.5,0.5 l0,5.3l0,8.5l0,2c0,0.2,0.1,0.3,0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0.1,0.2,0.1,0.4,0.1l11.8,0l1.7,0c0.3,0,0.5-0.2,0.5-0.5l0-1 c0-0.3-0.2-0.5-0.5-0.5l-10.5,0l0-5.3l8.9,0l1.5,0c0.3,0,0.5-0.2,0.5-0.5l0-1c0-0.3-0.2-0.5-0.5-0.5l-10.5,0l0-5.3L128,81.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M111.1,81.2l1.5,0c0.3,0,0.5-0.2,0.5-0.5l0-1c0-0.3-0.2-0.5-0.5-0.5l-11.8,0l-1.7,0c-0.3,0-0.5,0.2-0.5,0.5 l0,5.3l0,8.5l0,2c0,0.2,0.1,0.3,0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0.1,0.2,0.1,0.4,0.1l11.8,0l1.7,0c0.3,0,0.5-0.2,0.5-0.5l0-1 c0-0.3-0.2-0.5-0.5-0.5l-10.5,0l0-5.3l8.9,0l1.5,0c0.3,0,0.5-0.2,0.5-0.5l0-1c0-0.3-0.2-0.5-0.5-0.5l-10.5,0l0-5.3L111.1,81.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M133.1,100.1c0,1.3,1.1,2.4,2.5,2.4c1.4,0,2.5-1.1,2.5-2.4c0-0.3-0.1-0.6-0.3-1 c-1.3,0.7-2.7,0.8-3.2,1.8c-0.1,0.1-0.1,0.2-0.1,0.3c0-0.1,0-0.2,0.1-0.3c0.2-0.7,1-1.2,1.8-1.7c0.7-0.4,0.9-1.3,0.5-2 c0,0,0,0,0,0c-0.8,1.6-2.6,2.3-2.8,3.6c0,0.1,0,0.2,0,0.3c0-0.1,0-0.2,0-0.3c-0.1-1.3,1.3-2.3,1.9-3.9c0.2-0.5,0.1-1.1-0.2-1.5 l0,0C135.4,97.6,133.1,98.6,133.1,100.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: -256.7482,
    cy: 353.8477,
    r: 0.3443,
    gradientTransform: "matrix(-25.2646 0 0 -24.7731 -6351.0571 8860.4629)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1A31E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F05530"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 133.1,
    y: 95.3,
    className: "st4",
    width: 4.9,
    height: 7.2
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_8_",
    d: "M131.9,99.3c0,1.2,0.7,2.3,1.7,3c-0.6-0.5-1-1.2-1.1-2.1c-0.2-2,3-3.5,2.6-6.4 C134.4,96.6,131.9,97.4,131.9,99.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_9_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_8_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_10_",
    cx: -258.0155,
    cy: 353.2573,
    r: 0.3443,
    gradientTransform: "matrix(28.8732 0 0 -28.3114 7583.2832 10094.083)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808184"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404041"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 131.9,
    y: 93.7,
    className: "st5",
    width: 3.6,
    height: 8.5
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.1,117.2v-15.8h8.9c2.5,0,4.6,1.9,4.6,4.2c0,1.5-0.9,3-2.4,3.7c1.4,0.7,2.4,2.2,2.4,3.7 c0,2.3-2,4.2-4.6,4.2H99.1z M108,108.7c1.9,0,3.4-1.4,3.4-3.2c0-1.8-1.5-3.2-3.4-3.2h-6.8v6.4H108z M111.4,112.9 c0-1.8-1.5-3.2-3.4-3.2h-6.8v6.4h6.8C109.9,116.1,111.4,114.7,111.4,112.9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.6,117.2v-5.3v-8.5v-2l-0.5,0.5h5.9h2.8c1.4,0,2.7,0.5,3.6,1.7c1.3,1.9,0.5,4.3-1.4,5.3 c-0.3,0.2-0.3,0.7,0,0.9c1.7,0.9,2.7,3,1.7,4.8c-0.7,1.4-2.2,2.1-3.7,2.1c-2.2,0-4.3,0-6.5,0h-2.4c-0.7,0-0.7,1,0,1h6.5 c0.8,0,1.6,0,2.4,0c1.9,0,3.8-1.1,4.6-2.8c1.1-2.3,0-4.9-2.2-6v0.9c1.9-1,3.1-3.2,2.4-5.3c-0.6-2-2.4-3.3-4.3-3.5 c-0.8-0.1-1.7,0-2.5,0h-4.2h-2.8c-0.3,0-0.5,0.2-0.5,0.5v5.3v8.5v2C98.5,117.8,99.6,117.8,99.6,117.2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108,109.2c1.7,0,3.3-1.1,3.8-2.8c0.5-1.7-0.4-3.4-1.9-4.2c-0.9-0.4-1.8-0.5-2.8-0.5h-3.4h-2.5 c-0.3,0-0.5,0.2-0.5,0.5v6.4c0,0.3,0.2,0.5,0.5,0.5H108c0.7,0,0.7-1,0-1h-6.8l0.5,0.5v-6.4l-0.5,0.5h4.8c0.6,0,1.3,0,1.9,0 c1.3,0,2.6,0.9,2.9,2.2c0.3,1.7-1.3,3.1-2.9,3.1C107.3,108.2,107.3,109.2,108,109.2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.9,112.9c0-1.3-0.7-2.5-1.9-3.1c-0.7-0.4-1.5-0.6-2.4-0.6h-4.9h-1.6c-0.3,0-0.5,0.2-0.5,0.5v6.4 c0,0.3,0.2,0.5,0.5,0.5h4h2.3c0.7,0,1.5-0.1,2.1-0.4C111,115.7,111.9,114.4,111.9,112.9c0-0.7-1-0.7-1,0c0,1.2-0.8,2.1-1.9,2.5 c-0.5,0.2-1.1,0.2-1.6,0.2h-4.7h-1.4l0.5,0.5v-6.4l-0.5,0.5h3.6h2.4c0.4,0,0.9,0,1.3,0c1.3,0.2,2.4,1.3,2.4,2.6 C110.9,113.6,111.9,113.6,111.9,112.9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.4,109.2c0-4.4,3.8-7.9,8.5-7.9c4.7,0,8.5,3.6,8.5,7.9c0,4.4-3.8,7.9-8.5,7.9S114.4,113.6,114.4,109.2  M130.3,109.2c0-3.8-3.3-6.9-7.4-6.9c-4.1,0-7.4,3.1-7.4,6.9c0,3.8,3.3,6.9,7.4,6.9C127,116.1,130.3,113,130.3,109.2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.9,109.2c0-3.2,2.3-6,5.3-7c3.1-1,6.8-0.2,9,2.3c2.1,2.4,2.4,5.8,0.7,8.5c-1.8,2.8-5.3,4.1-8.5,3.5 C117.8,115.8,114.9,112.9,114.9,109.2c0-0.7-1-0.7-1,0c0,3.6,2.5,6.7,5.9,7.9c3.5,1.2,7.6,0.3,10.1-2.5c2.4-2.7,2.8-6.7,0.8-9.7 c-2-3.1-5.9-4.6-9.5-4c-4,0.7-7.3,4.1-7.3,8.3C113.9,109.9,114.9,109.9,114.9,109.2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.9,109.2c0-3.2-2.2-5.9-5.2-6.9c-3.1-1.1-6.7-0.2-8.9,2.2c-2.1,2.4-2.4,5.8-0.7,8.5 c1.8,2.8,5.2,4,8.4,3.4C128,115.8,130.8,112.8,130.9,109.2c0-0.7-1-0.7-1,0c0,2.8-2,5.1-4.5,6c-2.7,0.9-5.8,0.2-7.7-2 c-1.8-2-2-5-0.6-7.3c1.5-2.3,4.5-3.5,7.2-3c3,0.6,5.5,3.1,5.6,6.2C129.8,109.9,130.9,109.9,130.9,109.2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118,109.2c0-2.5,2.2-4.6,5-4.6c2.7,0,5,2.1,5,4.6c0,2.5-2.2,4.6-5,4.6C120.2,113.8,118,111.8,118,109.2  M127.2,109.2c0-2.2-1.9-4-4.3-4c-2.4,0-4.3,1.8-4.3,4c0,2.2,1.9,4,4.3,4C125.3,113.2,127.2,111.4,127.2,109.2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.5,109.2c0-1.8,1.3-3.3,2.9-3.8c1.7-0.6,3.7-0.1,5,1.3c1.2,1.3,1.3,3.2,0.4,4.7c-1,1.5-2.9,2.2-4.6,1.9 C120.1,112.9,118.5,111.3,118.5,109.2c0-0.7-1-0.7-1,0c0,2.2,1.5,4.1,3.6,4.8c2.1,0.7,4.6,0.2,6.1-1.5c1.4-1.6,1.7-4,0.5-5.9 c-1.2-1.9-3.6-2.8-5.8-2.4c-2.4,0.4-4.4,2.5-4.4,5C117.4,109.9,118.5,109.9,118.5,109.2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.8,109.2c0-2-1.4-3.6-3.2-4.2c-1.9-0.6-4.1-0.1-5.4,1.4c-1.2,1.5-1.4,3.6-0.3,5.2c1.1,1.7,3.2,2.4,5.1,2 C126.1,113.2,127.7,111.4,127.8,109.2c0-0.7-1-0.7-1,0c0,1.5-1.1,2.8-2.5,3.3c-1.5,0.5-3.2,0.1-4.2-1.1c-1-1.1-1.1-2.7-0.3-3.9 c0.8-1.3,2.5-1.9,4-1.7c1.7,0.3,3.1,1.7,3.1,3.4C126.7,109.9,127.8,109.9,127.8,109.2"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "133.9,117.2 133.9,104.8 136.8,104.8 136.8,117.2 134.9,117.2  "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134.5,117.2v-10.9v-1.5l-0.5,0.5h2.8l-0.5-0.5v10.9v1.5l0.5-0.5h-2.8c-0.7,0-0.7,1,0,1h2.8 c0.3,0,0.5-0.2,0.5-0.5v-10.9v-1.5c0-0.3-0.2-0.5-0.5-0.5h-2.8c-0.3,0-0.5,0.2-0.5,0.5v10.9v1.5 C133.4,117.8,134.5,117.8,134.5,117.2"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "140.3,117.2 140.3,101.3 142.8,101.3 142.8,116.1 153.8,116.1 153.8,117.2 153.6,117.2  "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.8,117.2v-5.3v-8.5v-2l-0.5,0.5h2.5l-0.5-0.5v5v8v1.8c0,0.3,0.2,0.5,0.5,0.5h9.6h1.3l-0.5-0.5v1l0.5-0.5 H142h-1.7c-0.7,0-0.7,1,0,1h11.8h1.7c0.3,0,0.5-0.2,0.5-0.5v-1c0-0.3-0.2-0.5-0.5-0.5h-9.6h-1.3l0.5,0.5v-5v-8v-1.8 c0-0.3-0.2-0.5-0.5-0.5h-2.5c-0.3,0-0.5,0.2-0.5,0.5v5.3v8.5v2C139.8,117.8,140.8,117.8,140.8,117.2"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "156.2,117.2 156.2,101.3 169.7,101.3 169.7,102.4 158.4,102.4 158.4,108.7 169.7,108.7 169.7,109.7  158.4,109.7 158.4,116.1 169.7,116.1 169.7,117.2 169.6,117.2  "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.7,117.2v-5.3v-8.5v-2l-0.5,0.5H168h1.7l-0.5-0.5v1l0.5-0.5h-9.9h-1.4c-0.3,0-0.5,0.2-0.5,0.5v6.3 c0,0.3,0.2,0.5,0.5,0.5h9.9h1.4l-0.5-0.5v1l0.5-0.5h-9.9h-1.4c-0.3,0-0.5,0.2-0.5,0.5v6.4c0,0.3,0.2,0.5,0.5,0.5h9.9h1.4l-0.5-0.5 v1l0.5-0.5h-11.8h-1.7c-0.7,0-0.7,1,0,1H168h1.7c0.3,0,0.5-0.2,0.5-0.5v-1c0-0.3-0.2-0.5-0.5-0.5h-9.9h-1.4l0.5,0.5v-6.4l-0.5,0.5 h9.9h1.4c0.3,0,0.5-0.2,0.5-0.5v-1c0-0.3-0.2-0.5-0.5-0.5h-9.9h-1.4l0.5,0.5v-6.3l-0.5,0.5h9.9h1.4c0.3,0,0.5-0.2,0.5-0.5v-1 c0-0.3-0.2-0.5-0.5-0.5h-11.8h-1.7c-0.3,0-0.5,0.2-0.5,0.5v5.3v8.5v2C155.7,117.8,156.7,117.8,156.7,117.2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.2,117v-4.5h0v-1h0v-9.2h0v-1h7.4c3.3,0,6.1,2.5,6.1,5.6c0,2.3-1.5,4.3-3.8,5.2l3.7,4.8l0.2,0.2h-1.4 l0-0.1l-3.6-4.6c-0.4,0.1-0.8,0.1-1.2,0.1h-5.3v4.6h-2.2L172.2,117L172.2,117z M184.5,106.9c0-2.5-2.2-4.6-4.9-4.6h-5.3v9.2h5.3 c0.2,0,0.4,0,0.6,0c0.3,0,0.6-0.1,0.9-0.2C183.1,110.7,184.5,108.9,184.5,106.9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.7,117v-4.5c0-0.3-0.2-0.5-0.5-0.5h0l0.5,0.5v-1l-0.5,0.5h0c0.3,0,0.5-0.2,0.5-0.5v-8v-1.2 c0-0.3-0.2-0.5-0.5-0.5h0l0.5,0.5v-1l-0.5,0.5h6.4c1.1,0,2.2,0,3.2,0.4c1.7,0.7,3.1,2.2,3.3,4.1c0.3,2.3-1.2,4.5-3.4,5.3 c-0.4,0.2-0.5,0.5-0.2,0.9c1.3,1.7,2.6,3.3,3.9,5l0.4-0.9h-1.4l0.4,0.2c-1.2-1.6-2.4-3.1-3.7-4.7c-0.1-0.2-0.3-0.2-0.5-0.1 c-1.1,0.2-2.3,0.1-3.4,0.1h-2.9c-0.3,0-0.5,0.2-0.5,0.5v4.6l0.5-0.5h-2.2l0.5,0.5L172.7,117c0-0.3-0.2-0.5-0.5-0.5h0 c-0.7,0-0.7,1,0,1h0l-0.5-0.5v0.1c0,0.3,0.2,0.5,0.5,0.5h2.2c0.3,0,0.5-0.2,0.5-0.5v-4.6l-0.5,0.5h3c1.2,0,2.4,0.1,3.6-0.1 c-0.2,0-0.3-0.1-0.5-0.1c0.6,0.8,1.2,1.6,1.8,2.4c0.6,0.8,1.1,1.6,1.8,2.3c0.2,0.3,0.6,0.2,0.9,0.2h0.9c0.5,0,0.6-0.5,0.4-0.9 c-1.3-1.7-2.6-3.3-3.9-5c-0.1,0.3-0.2,0.6-0.2,0.9c2.1-0.8,3.7-2.6,4.1-4.8c0.3-2.1-0.6-4.2-2.2-5.5c-1.3-1.1-2.9-1.5-4.6-1.5 h-3.8h-3.4c-0.3,0-0.5,0.2-0.5,0.5v1c0,0.3,0.2,0.5,0.5,0.5h0l-0.5-0.5v8v1.2l0.5-0.5h0c-0.3,0-0.5,0.2-0.5,0.5v1 c0,0.3,0.2,0.5,0.5,0.5h0l-0.5-0.5v4.5C171.6,117.7,172.7,117.7,172.7,117"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185,106.9c0-2.5-2-4.6-4.5-5c-0.6-0.1-1.2-0.1-1.8-0.1h-2.6h-1.8c-0.3,0-0.5,0.2-0.5,0.5v8v1.2 c0,0.3,0.2,0.5,0.5,0.5h3.9c0.5,0,1,0,1.4,0c1.4,0,2.7-0.5,3.7-1.4C184.4,109.7,185,108.3,185,106.9c0-0.7-1-0.7-1,0 c0,2.4-2.2,4-4.4,4.1c-1.2,0-2.5,0-3.7,0h-1.5l0.5,0.5v-8v-1.2l-0.5,0.5h3.7c0.5,0,1,0,1.5,0c1,0,2,0.3,2.8,0.9 c1,0.7,1.6,1.9,1.6,3.2C184,107.6,185,107.6,185,106.9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.70198affc931c7abf7ae82bde239de67.svg";
export { ForwardRef as ReactComponent };